import { useEffect, useState, useMemo, useRef } from "react";
import "./styles.css";

import { ArrowForwardIosRounded, ArrowForwardRounded, ArrowRightRounded, ChevronRightRounded } from "@material-ui/icons";

import "react-multi-carousel/lib/styles.css";

import CarouselPure from "react-multi-carousel";
import { AvailableComponents } from "../Components";

export default function Carousel({ config }) {
    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);

    // Measure container width on mount and resize
    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        // Initial measurement
        const updateWidth = () => {
            if (container) {
                const width = container.getBoundingClientRect().width;
                setContainerWidth(width);
            }
        };

        // Initial measurement
        updateWidth();

        // Use ResizeObserver for efficient resize detection
        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                const width = entry.contentRect.width;
                setContainerWidth(width);
            }
        });

        resizeObserver.observe(container);

        // Fallback for older browsers
        const handleResize = () => {
            updateWidth();
        };
        window.addEventListener('resize', handleResize);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Calculate responsive configuration based on actual container width
    const responsive = useMemo(() => {
        if (!config.items || config.items.length === 0) {
            return {
                desktop: { breakpoint: { max: 3000, min: 0 }, items: 1 }
            };
        }

        const itemWidth = config.itemWidth || 200; // Fixed width for each item
        const spacing = 20; // Spacing between items
        const totalItemWidth = itemWidth + spacing; // Width including spacing

        // Calculate how many items can fit in the actual container width
        const calculateItemsToShow = (containerWidth) => {
            if (containerWidth <= 0) return 1;
            const itemsToShow = Math.floor(containerWidth / totalItemWidth);
            return Math.max(1, itemsToShow); // At least show 1 item
        };

        // Use actual container width if available, otherwise use window width as fallback
        const currentWidth = containerWidth > 0 ? containerWidth : (typeof window !== 'undefined' ? window.innerWidth : 1024);
        const itemsToShow = calculateItemsToShow(currentWidth);

        // Create responsive breakpoints that adapt to the actual container width
        // We create breakpoints that will match the current container size
        const responsiveConfig = {
            desktop: {
                breakpoint: { max: 4000, min: 0 },
                items: itemsToShow
            }
        };

        return responsiveConfig;
    }, [config.itemWidth, config.items, containerWidth]);

    return (
        <div ref={containerRef} className="carousel-wrapper">
            <CarouselPure
                autoPlay={true}
                infinite={true}
                responsive={responsive}
                customTransition="transform 500ms ease-in-out"
                transitionDuration={500}
                showDots={false}
                itemWidth={config.itemWidth}
            >
                {config.items.map((content, i) => {
                    const Component = AvailableComponents[content.type];
                    return <Component key={"component-" + i} config={content.settings} />;
                })}
            </CarouselPure>
        </div>
    )
}